export const environment = {
  production: true,
  version: 'b2ae05c9ba'
};
